import type {
  Info as ApiInfo,
  InfoChoice as ApiInfoChoice,
  InfoChoiceData as ApiInfoChoiceData,
  InfoFileData as ApiInfoFileData,
  InfoLocation as ApiInfoLocation,
  InfoTextData as ApiInfoTextData,
} from '../services/api/generated/model';

export interface InfoTypeOption {
  label: string;
  value: InfoType;
}

export enum InfoType {
  CHOICE = 1,
  TEXT = 2,
  FILE = 3,
  IMAGE = 4,
  UNKNOWN = -42,
}

export type Info = Omit<ApiInfo, 'description' | 'type' | 'isUsed' | 'sortNr'> & {
  description: string;
  type: InfoType;
  isUsed?: boolean;
  choiceListId?: number;
};

// Pure join entities lack a backend name; the phantom is kept so they fit GenericStore.
export type InfoChoice = ApiInfoChoice & { name: string };
export type InfoLocation = ApiInfoLocation & { name: string };
export type InfoTextData = ApiInfoTextData & { name: string };
export type InfoChoiceData = ApiInfoChoiceData & { name: string };
export type InfoFileData = ApiInfoFileData & { name: string };
